import {
  IMarketStat,
  IMarketStatCollectionFilters,
  IMarketStatFilterPayload,
  IMarketStatsBasePayload,
} from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketStat';
import { IMarketCategory } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketCategory';
import {
  initialStatsTileBasePayload,
  initialStatsTileCollectionFiltersState,
} from './constants';

interface IStatsTilePayload {
  payload: IMarketStatsBasePayload,
  collectionFilters: IMarketStatCollectionFilters,
}

export const getStatsTilePayload = (
  filter: Partial<IMarketStatFilterPayload>,
): IStatsTilePayload => ({
  payload: {
    ...initialStatsTileBasePayload,
    filter,
  },
  collectionFilters: initialStatsTileCollectionFiltersState,
});

export const mapCategoriesNames = (
  collection: IMarketStat[],
  categoriesMap: Record<string, IMarketCategory>,
): (IMarketStat & { categoriesNames: string[] })[] =>
  collection.map((item) => ({
    ...item,
    categoriesNames: item.categories
      .map((id) => categoriesMap[id]?.name)
      .filter((name): name is string => Boolean(name))
      .sort(),
  }));
